var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_4247","data-name":"Group 4247","transform":"translate(-307.064 -89.065)"},[React.createElement("rect",{"id":"Rectangle_464","data-name":"Rectangle 464","width":"35","height":"3","transform":"translate(309.187 89.065) rotate(45)","key":0}),React.createElement("rect",{"id":"Rectangle_465","data-name":"Rectangle 465","width":"35","height":"3","transform":"translate(333.935 91.187) rotate(135)","key":1})]));
}

Close.defaultProps = {"fill":"#fff","width":"1em","height":"1em","viewBox":"0 0 26.87 26.87"};

module.exports = Close;

Close.default = Close;
